import { render, staticRenderFns } from "./Focus.vue?vue&type=template&id=39999c22&scoped=true&"
import script from "./Focus.vue?vue&type=script&lang=js&"
export * from "./Focus.vue?vue&type=script&lang=js&"
import style0 from "./Focus.vue?vue&type=style&index=0&id=39999c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39999c22",
  null
  
)

export default component.exports